import { Injectable } from '@angular/core';
import { Profile } from './profile';
import { THEME } from './theme';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private _profile!: Profile;
  private _isAOCustomer: boolean = false;
  private _isTestable: boolean = false;
  private _allowSubscriberTermination: boolean = false;
  private _hasSystemRoleGroups: boolean = false;
  private _onPremiseIntegration: boolean = false;

  get profile(): Profile {
    return this._profile;
  }

  set profile(profile: Profile) {
    this._profile = profile;
  }

  get isAOCustomer(): boolean {
    return this._isAOCustomer;
  }

  set isAOCustomer(isAOCustomer: boolean) {
    this._isAOCustomer = isAOCustomer;
  }

  get isTestable(): boolean {
    return this._isTestable;
  }

  set isTestable(isTestable: boolean) {
    this._isTestable = isTestable;
  }

  get allowSubscriberTermination(): boolean {
    return this._allowSubscriberTermination;
  }

  set allowSubscriberTermination(allowSubscriberTermination: boolean) {
    this._allowSubscriberTermination = allowSubscriberTermination;
  }

  get hasSystemRoleGroups(): boolean {
    return this._hasSystemRoleGroups;
  }

  set hasSystemRoleGroups(hasSystemRoleGroups: boolean) {
    this._hasSystemRoleGroups = hasSystemRoleGroups;
  }

  get onPremiseIntegration(): boolean {
    return this._onPremiseIntegration;
  }

  set onPremiseIntegration(onPremiseIntegration: boolean) {
    this._onPremiseIntegration = onPremiseIntegration;
  }

  setTheme(newTheme: string): void {
    const body = document.body;
    if (body) {
      const parent = body.parentElement;
      if (parent) {
        Object.values(THEME).forEach(theme => {
          parent.classList.remove(theme);
        });
        parent.classList.add(newTheme);
      }
    }
  }
}
